import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { forwardRef, useImperativeHandle, useState } from "react";
import RequiredMark from "./RequiredMark";

interface InputDateProps {
    label: string;
    isRequired: boolean;
    initValue: string;
    beforeDate?: string;
    beforeToday?: boolean
    afterDate?: string;
}

const InputDate = forwardRef((props: InputDateProps, ref) => {
    function checkBeforeDate(before: string, after: string) {
        var dateBefore = new Date(before);
        var dateAfter = new Date(after);
        return dateBefore <= dateAfter
    }

    const [date, setDate] = useState<string>(getDefaultValue(props.initValue));
    const [dateError, setDateError] = useState<string>("");
    const validateDate = () => {
        if (props.isRequired && !date) {
            setDateError("Data jest wymagana");
            return false;
        } else if (props.beforeDate != undefined && props.beforeDate != "" && !checkBeforeDate(date, props.beforeDate)) {
            setDateError("Wybierz datę przed " + printDate(new Date(props.beforeDate)));
            return false;
        } else if (props.beforeToday != undefined && props.beforeToday && !checkBeforeDate(date, new Date().toString())) {
            setDateError("Wybierz datę przed " + printDate(new Date()));
            return false;
        } else if (props.afterDate != undefined && props.afterDate != "" && !checkBeforeDate(props.afterDate, date)) {
            setDateError("Wybierz datę po " + props.afterDate);
            return false;
        } else {
            setDateError("");
            return true
        }
    };

    useImperativeHandle(ref, () => ({
        validate: () => validateDate(),
        value() { return date; }
    }));

    return (
        <FormControl isInvalid={!!dateError}
            mt="5"
        >
            <FormLabel>{props.label} {props.isRequired && <RequiredMark />}</FormLabel>
            <Input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                onBlur={validateDate}
            />
            <FormErrorMessage>{dateError}</FormErrorMessage>
        </FormControl>
    );
});

function printDate(date: Date) {
    return ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '-' 
        + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '-' +
        date.getFullYear();
}

export default InputDate;

function getDefaultValue(value: string): string{
    if(!value) return ""
    return value.split("T")[0]
}
